import taskTypeIcon from '@atom/components/common/svgIcons/taskType.svg';
import { Icon, IconButton, Menu } from '@atom/mui';
import { AddIcon } from '@atom/mui/icons';

import classes from './tasks.module.css';

const { MenuItem } = Menu;

type AddTaskMenuProps = {
  requireTaskType: boolean;
  onChooseTemplate: () => void;
  onAddBlank: () => void;
};

const AddTaskMenu = (props: AddTaskMenuProps) => {
  const { requireTaskType, onChooseTemplate, onAddBlank } = props;

  if (requireTaskType) {
    return (
      <IconButton
        size="small"
        onClick={onChooseTemplate}
        data-cy="createWorkModalAddTaskButton"
      >
        <Icon icon={AddIcon} />
      </IconButton>
    );
  }

  return (
    <Menu
      IconProps={{ icon: AddIcon }}
      IconButtonProps={{ size: 'small' }}
      dataCyLabel="createWorkModalAddTaskButton"
    >
      <div className={classes.menuHeader}>add task</div>
      <MenuItem
        startAdornment={
          <Icon>
            <img src={taskTypeIcon} alt="" />
          </Icon>
        }
        onClick={onChooseTemplate}
        data-cy="createWorkModalAddTaskChooseTemplate"
      >
        Choose from Templates
      </MenuItem>
      <MenuItem
        startAdornment={<Icon icon={AddIcon} />}
        onClick={onAddBlank}
        data-cy="createWorkModalAddTaskWithoutTemplate"
      >
        Without a Template
      </MenuItem>
    </Menu>
  );
};

export default AddTaskMenu;
